import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const fileSizeValidator = (maxFileSize: number, kilobytes?: boolean, returnMb?: boolean): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const file: File = control.value;
    const maxFileSizeInKB = kilobytes ? maxFileSize : maxFileSize * 1000;

    if (file.size > maxFileSizeInKB) {
      if (returnMb) {
        const maxSize = (maxFileSize / (1024 * 1024)).toFixed(1);
        return { fileSize: { maxFileSize: maxSize } };
      } else {
        return { fileSize: { maxFileSize: maxFileSizeInKB } };
      }
    }

    return null;
  };
};
